import React from "react";
import { Collapse } from "react-collapse";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

const FaqItem = ({ toggle, open, question, answer, bottomBorder }) => {
  return (
    <div
      className={
        bottomBorder
          ? "sm:w-[75%]  border-b border-black max-w-screen-xl mx-auto"
          : "sm:w-[75%] border-black max-w-screen-xl mx-auto"
      }
      onClick={toggle}
    >
      <div className="  h-max  sm:text-2xl text-xs max-w-screen-xl mx-auto flex justify-between items-center py-3  px-1">
        <h2 className=" font-bold text-underline ">{question}</h2>
        <div>{open ? <AiOutlineMinus /> : <AiOutlinePlus />}</div>
      </div>
      <Collapse isOpened={open}>
        <div className="text-xs sm:text-2xl max-w-screen-xl mx-auto sm:w-[90%] p-4">
          {answer}
        </div>
      </Collapse>
    </div>
  );
};

export default FaqItem;

//
